/**
 * Exit route after finishing a client's nutrition plan in the planner (coach client mode).
 * Nutrition coaching is managed from the coach dashboard.
 */
export function getClientNutritionPlanExitPath() {
  return '/coach/dashboard';
}
